// 24 小时
export const DEFAULT_EXPIRE_TIME = 24 * 3600;

// 单一变量合集
export const VARIABLE_GARD_TOKEN = 'VGTToken';

// localStorage key值集合
export enum LSK {
	LAST_CACHED_FEEDS = 'LastCachedFeeds', // 缓存的最后一屏数据
	LAST_CACHED_FEEDS_VERSION = 'LastCachedFeedsVersion', // 缓存的最后一屏数据的版本
	AB_TEST_ID = 'ABtestId', // AB Test ID
	APP_VERSION = 'app_version', // webview app 当前版本号
	CACHE_REFRESH_TOKEN = 'CACHE_REFRESH_TOKEN', // 用来检查浏览器是不是刷新
	CREATE_DATE = 'createdate', // 埋点
	EVENT_TRACKING_DATA = 'event_tracking_data', // 埋点参数
	FROM = 'from', // 记录是从哪里进App页的（有必要吗
	HAS_SHOWN_RATING_POPUP = 'hasShownRatingPopup', // 表示是否已经展示过评分弹窗
	COUNTDOWN_START_TIME = 'countdownStartTime',
	CREDIT_PACK_TIME = 'creditpacktime',
	GOOGLE_PLAY_REFERRER = 'google_play_referrer',
	GOOGLE_AD_ID = 'google_ad_id',
	DEEPLINK_APP_INSERTED = 'deeplink_app_inserted',
	QUICK_GENERATE = 'quickGenerate', // 埋点。。。
	INVITE_CODE_MAP = 'inviteCodeMap', // 邀请码
	IS_FROM_INDEX_PLAY = 'IS_FROM_INDEX_PLAY', // 是否来自首页玩一玩
	LAST_LOGIN_DATE = 'lastLoginDate', // 老用户每日登录 'lastLoginDate' + userId.slice(-5)
	LOAD_PWA_APP = 'loadPwaApp', // 第一次打开pwa
	MAIN_IMAGE_ID = 'mainImageId', // 埋点
	ORIGIN = 'origin', // 埋点
	UN_MODIFIED_APP = 'unModifiedApp',
	PLAN = 'plan', // 埋点
	PIC_ORIGIN = 'pic_origin', // 埋点
	RANK_LOCATION = 'rankLocation', // 埋点
	SOURCE = 'source', // 埋点
	SUBSCRIBE_LOCATION = 'subscribeLocation', // 埋点
	TASK_DOWNLOAD = 'taskDownload', // 埋点
	TASK_OPTIMIZE = 'taskOptimize', // 埋点
	TASK_PUBLISH = 'taskPublish', // 埋点
	TEMPLATE_APP_PARAMS_DATA = 'template_app_params_data', // 一件同款
	TEMPLATE_CARD_CACHE = 'templateCardCache', // 一件同款
	TRACE_ID = 'traceId', // 埋点
	UNIQUE_ID = 'uniqueID', // ABTest
	USER_LOCATION = 'userLocation', // 埋点
	VISIT_RECORD = 'visitRecord', // 埋点
	VISIT_REF_RECORD = 'visitRefRecord', // 埋点
	FIRST_SHOW_V2_POPUP = 'firstShowV2Popup', // 埋点
	GENERATE_BUTTON_CLICK_PROPS = 'generate_button_click_props', // 埋点
	S_P = 's_p', //支付页面展示
	SEARCH_KEYWORD = 'searchKeyword',
	SEARCH_METHOD = 'searchMethod',
	IS_FIRST_REQUEST = 'isFirstRequest',
	GENERATE_BUTTON_TYPE = 'generate_button_type', //埋点
	DEVICE_BRAND = 'device_brand', // 设备品牌, 埋点需要
	DEVICE_MODEL = 'device_model', // 设备型号, 埋点需要
	DEVICE_ID = 'device_id', // 设备id
	NEW_LANGUAGE_AR_SA = 'newLanguageArSa', // 新语言提示
	NEW_LANGUAGE_KOR = 'newLanguageKor', // 新语言提示
	SUBSCRIBE_UPGRADE_TIME = 'subscribeUpgradeTime', // 订阅升级弹窗出现的时间
	FREE_TRIAL_COUNTDOWN_TIME = 'freeTrialCountdownTime', // 免费试用倒计时
	PAID_RETENTION_C_POPUP = 'paidRetentionCPopup', // 付费留存 C弹窗 强化超低价
	Old_USER_PAY_GUIDE_COUNTDOWN = 'oldUserPayGuideCountdown', // 付费留存 C弹窗 倒计时
	USER_COUNTRY = 'user_country', // 用户国家, 仅app内可用
	USER_LANGUAGE = 'user_language', // 用户语言
	RENEW_RETENTION_TIME = 'renewRetentionTime',
	RENEW_SUBSCRIBE_POPUP_DATA = 'renewSubscribeData', // 续费弹窗 倒计时
	USER_PATH_LOAD = 'userPathLoad', // 标识是否是已启动过的老用户
	CONTROL_IOS_SHARAE_PANEL = 'CONTROL_IOS_SHARAE_PANEL', // ios 是否关闭过提示
	GENERATE_IMAGE_REPORTED = 'generateImageReported', // 表示是否已经向 facebook回传过生图
	REFERRER_DECODE_RESULT = 'referrerDecodeResult', // 解析后的referrer结果
	GOOGLE_REPORTED_SUBSCRIBE = ' googleReportedSubscribe', // 表示是否像 google 回传过订阅
	ONBOARDING_PURCHASE_SHOW = 'onboardingPurchaseShow',
	PAY_CANCEL_RECOVERY = 'payCancelRecovery', // 支付取消挽回持久化状态

	VIEW_LATER_GUIDE_POPUP_DATE = 'viewLaterGuidePopupDate', // 稍后查看 引导开启通知权限弹窗 日期记录
	// 测试工具相关
	OPEN_DEV_TOOL_IN_PROD = 'openDevToolInProd', // 生产环境是否打开开发工具
	OPEN_WEB_DEV_TOOL = 'openWebDevTool', // web 端是否打开内部调试工具
	AEO_ID = 'aeoId',
	SUBSCRIBE_TEST_NEED_RELOAD = 'subscribeTestNeedReload', // 订阅后是否需要刷新
	USER_TYPE_FOR_TEST = 'userTypeTest', // 用户类型 测试
	APP_ORIGIN_FOR_TEST = 'app_origin_for_test', // 测试工具：覆盖 X-App-Origin 的值
	GETUI_CID = 'getui_cid', // 个推调试 cid
	TRACK_RECORDER_TASK = 'trackRecorder_task',
	TEST_TOOL_ENTRY_POS = 'testToolEntryPos', // 记录测试工具入口位置
	// 记录h5登录用户是否是第一次点击生成按钮（全局任意一处
	OPEN_IMPORT_MODAL_KEY = 'openImportModalKey',
	RECOMMEND_BANNER_INFO = 'recommendBannerInfo',

	DEBUG_SUBSCRIPTION_DATA = 'debugSubscriptionData', // 调试用的订阅数据（包含 subscriptionInfoList 和 oneTimeProductInfoList）
	DEBUG_CREDIT_PACK_AVAILABLE = 'debug_credit_pack_available', // 调试用：强制开启加量包能力
	DEBUG_SHOW_STUDIO_PAGE = 'debug_show_studio_page', // 调试用：强制展示 Studio 页
	/**
	 * @desc 社区相关本地存储
	 */
	SEARCH_HISTORY = 'searchHistory', // 社区搜索历史
	SEARCH_HOT_TERMS = 'searchHotTerms', // 社区搜索热词
	SEARCH_RECOMMEND_TERMS = 'searchRecommendTerms', // 社区搜索推荐词
	POPOVER_USER_MAP = 'popoverUserMap', // 用户id与弹出过气泡的记录map
	USER_BEHAVIOR_MAP = 'user_behavior_map',
	BUILD_STATE = 'buildState', // remix表单状态
	BUILD_POPUP_TEXT = 'buildPopupText', // remix文本组件弹窗文案
	DES_CHANGED = 'desChanged', // remix文本组件弹窗文案修改
	REMIX_VIDEO_PROMPT_CHANGED = 'remix_video_prompt_changed', // remix视频组件弹窗文案修改
	REMIX_VIDEO_POPUP_CLOSE_WAY = 'remix_video_popup_close_way', // remix视频组件弹窗关闭方式
	HAS_MUTED_TOAST = 'hasMutedToast', // 是否展示过静音提示
	LAST_SHOW_FIVE_RATE_GUIDE_TIME = 'lastShowFiveRateGuideTime', // 五星好评引导上次弹出时间（下载/分享共用）
	HAS_SHOWN_FIVE_RATE_GUIDE = 'hasShownFiveRateGuide', // 用户已点击去评分，不再弹出
	BANNER_EXPOSE = 'BANNER_EXPOSE',
	BUILD_TOOLTIP_VIDEO_GENERATE = 'build_tooltip_video_generate', // 视频生成组件tooltip
	HAS_GENERATED_IMAGE = 'hasGeneratedImage', // 是否生成过图片==>用于判断是否展示引导弹窗
	SHOW_IDPHOTO_GUIDE = 'showIDPhotoGuide', // 证件照片生成引导
	SHOW_DRESSUP_GUIDE = 'showDressUpGuide', // 换装生成引导
	SHOW_ONBOARDING_GUIDE = 'showOnboardingGuide', // 新用户引导
	HAS_USED_STUDIO = 'hasUsedStudio', // 是否使用过原子能力
	HAS_CLICK_STUDIO = 'hasClickStudio', // 是否点击过原子能力
	HAS_CLICK_NO_ENOUGH_TIP = 'hasClickNoEnoughTip',
	FLOW_VIDEO_TOOLTIP = 'flow_video_tooltip',
	CHATBOT_GUIDE = 'chatbot_guide', // chatbot引导信息
	EVENT_DATA_QUEUE = 'event_data_queue', // 埋点存储
	// 记录设备gpu信息
	DEVICE_GPU = 'device_gpu',
	R18_CONFIRM_IN_TIME = 'R18_CONFIRM_IN_TIME',
	Old_USER_PAY_GUIDE_POPUP_DATE = 'oldUserPayGuidePopupDate', // 老用户付费弹窗 日期记录
	APP_SOURCE = 'app_source', // 应用来源
	APP_SOURCE_SHORT = 'app_source_short', // 应用来源
	APP_SOURCE_VISIT = 'app_source_visit', // 应用来源
	// 记录页面刷新是否为订阅刷新，用于判断是否需要弹出商业化弹窗
	IS_SUBSCRIBE_REFRESH = 'isSubscribeRefresh',
	SHOW_STUDIO_STATE = 'showStudioState',
	CREDITS_BUBBLE_STATE = 'credits_bubble_state', // 记录积分气泡状态-chatbot合集页积分气泡提示
	CHATBOT_COMPLIANCE_BUBBLE_SHOWN = 'chatbot_compliance_bubble_shown', // 记录 chatbot 合规气泡是否展示过
	CHATBOT_DEEPLINK_INSERTED = 'chatbot_deeplink_inserted', // 标记是否已经插入过deeplink app了
	CHATBOT_FREE_CHAT_PAID_TOAST_USER_ID = 'chatbot_free_chat_paid_toast_user_id', // 记录Chatbot免费对话用户是否已经展示过付费提示toast
}

// sessionStorage key值集合
export enum SSK {
	CURRENT_TAB = 'currentTab', // 埋点
	APP_DETAIL_LABEL = 'appDetailLabel', // 埋点
	LABEL_ID = 'labelId', // 应用标签
	LABEL_NAME = 'labelName', // 应用标签
	EXPOSURE_ARRAY = 'exposureArray', // 曝光数组
	FILE_SELECTED = 'file-selected', // 合照
	INVITE = 'invite', // 埋点
	PREVIOUS_PATHNAME = 'previousPathname', // 埋点
	ROOM_ID = 'ROOM_ID', // 房间Id
	SESSION_ID = 'sessionId', // 埋点
	TRACKING_COUNT = 'trackingCount', // 埋点
	PAYMENT_LOCATION = 'paymentLocation',
	PAYMENT_ORIGIN_URL = 'paymentOriginUrl',
	// blog那边保存渠道页!!!! 跨项目使用！！！！
	REFER_URL_BLOG = 'refer_url_blog',
	// 记录最开始的进入的页面
	ENTRANCE_URL = 'entrance_url',
	// 上一张
	IMGDATA = 'imgData',
	PATH = 'path',
	// 设置是否需要弹出登录绑定弹窗
	NEED_SHOW_LOGIN_BIND_POPUP = 'needShowLoginBindPopup',
	// web端生图按钮点击时记录ability_name
	WEB_GENERATE_ABILITY_NAME = 'webGenerateAbilityName',
	REF_CHANGE = 'REF_CHANGE',
	GENERATE_SUCCESS_COUNT = 'generate_success_count',
	FREE_COUNT = 'free_count', // 免费生成次数
	CONSUME_COUNT = 'consume_count', // 付费生成次数
	REMIX_INPUT_IMAGE = 'remix_input_image',
	REMIX_INPUT_TEXTS = 'remix_input_texts',
	IS_SUBSCRIBE_SUCCESS = 'is_subscribe_success',
	AD_APP_SHORT_ID = 'ad_app_short_id', // 广告app short id
}
